import type { ButtonProps } from '@ori-ui/mui';
import { Button } from '@ori-ui/mui';
import { useFormatCurrency } from '@ori/culture-provider';
import { forwardRef, useMemo } from 'react';

import { translationKeys } from '../constants';
import { useAppContext } from '../context';

export const BuyForPointsButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { translations, data } = useAppContext();
  /**
   * Formatted currency value
   */
  const loyaltyPrice = useFormatCurrency(data.loyaltyPrice ?? 0);

  const formattedLoyaltyPoints = useMemo(
    () => translations[translationKeys._0P].replaceAll('{0}', String(data.loyaltyPoints ?? 0)),
    [translations, data.loyaltyPoints],
  );

  const formattedLoyaltyPrice = useMemo(
    () => translations[translationKeys.loyaltyPrice].replaceAll('{0}', String(loyaltyPrice)),
    [translations, loyaltyPrice],
  );

  return (
    <Button
      ref={ref}
      fullWidth
      variant="contained"
      color="primary"
      {...props}
    >
      {formattedLoyaltyPoints}
      {data.loyaltyPrice !== 0 && formattedLoyaltyPrice}
    </Button>
  );
});
